import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDepartments,
  createDepartment,
  deleteDepartment
} from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import Swal from 'sweetalert2';
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

const Department = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const { departments, loading, success, error } = useSelector((state) => state.DepartmentMaster || {});
  const [authDetails, setAuthDetails] = useState(null);

  // useEffect(() => {
  //   if (loading) {
  //     dispatch(fetchDepartments(authDetails?.unit_id));
  //   }
  // }, [loading, authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchDepartments(unitId));
  }, [dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      departmentId: 0,
      departmentcode: "",
      departmentname: "",
      createdby: authDetails?.user_id,
      unit_id: authDetails?.unit_id,
    },
    validationSchema: Yup.object({
      departmentcode: Yup.string()
        .required("Please Enter Department Code")
        .max(10, "Department Code must not exceed 10 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Department Code allows only alphabets, numbers and spaces"
        ),

      departmentname: Yup.string()
        .required("Please Enter Department Name")
        .max(50, "Department Name must not exceed 50 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Department Name allows only alphabets, numbers and spaces"
        ),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("dept_id", values.departmentId);
      formData.append("depart_code", values.departmentcode);
      formData.append("depart_name", values.departmentname);
      formData.append("created_by", values.createdby);
      formData.append("unit_id", values.unit_id);

      dispatch(createDepartment(formData, isEdit));
      setIsEdit(false);
      console.log('success > ', success)
      formik.resetForm(); // Reset form fields after submission
    },
  });


  const handleEdit = (row) => {
    formik.setValues({
      departmentId: row.departmentId,
      departmentcode: row.departmentcode,
      departmentname: row.departmentname,
      createdby: authDetails?.user_id,
      unit_id: authDetails?.unit_id,
    });
    setIsEdit(true);
    setEditId(row.departmentId);
  };


  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  // const columns = useMemo(() => [
  //   {
  //     Header: "Action",
  //     Cell: (cellProps) => (
  //       <div className="d-flex gap-3">
  //         <Link
  //           to="#"
  //           className="text-success"
  //           onClick={() => handleEdit(cellProps.row.original)}
  //         >
  //           <i className="bx bxs-edit font-size-18" id={`edittooltip-${cellProps.row.original.departmentId}`} />
  //           <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.departmentId}`}>
  //             Edit
  //           </UncontrolledTooltip>
  //         </Link>
  //         <Link
  //           to="#"
  //           className="text-danger"
  //           onClick={() => {
  //             handleToggleStatus(cellProps.row.original);
  //           }}
  //         >
  //           <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
  //           <UncontrolledTooltip placement="top" target="deletetooltip">
  //             Delete
  //           </UncontrolledTooltip>
  //         </Link>
  //       </div>
  //     ),
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => departments.length - row.index,
  //           className: "serial-no",
  //     applyHeaderClass: true,
  //   },
  //   {
  //     Header: "Department Code",
  //     accessor: "departmentcode",
  //   },
  //   {
  //     Header: "Department Name",
  //     accessor: "departmentname",
  //   },
  //   {
  //     Header: "Created By",
  //     accessor: "createdby",
  //   },
  //   {
  //     Header: "Created On",
  //     accessor: "createddate",
  //   },
    
  // ], [departments]);

  const columns = useMemo(() => {
    // Action Column (conditionally added)
    const actionColumn =
      canEdit || canDelete
        ? {
            Header: "Action",
            Cell: (cellProps) => {
              const uniqueId = cellProps.row.original.departmentId;

              return (
                <div className="d-flex gap-3">
                  {/* Edit Access */}
                  {canEdit && (
                    <Link
                      to="#"
                      className="text-success"
                      onClick={() => handleEdit(cellProps.row.original)}
                    >
                      <i
                        className="bx bxs-edit font-size-18"
                        id={`edittooltip-${uniqueId}`}
                      />
                      <UncontrolledTooltip
                        placement="top"
                        target={`edittooltip-${uniqueId}`}
                      >
                        Edit
                      </UncontrolledTooltip>
                    </Link>
                  )}

                  {/* Delete / Status Toggle Access */}
                  {canDelete && (
                    <Link
                      to="#"
                      className="text-danger"
                      onClick={() => handleToggleStatus(cellProps.row.original)}
                    >
                      <i
                        className="mdi mdi-delete font-size-18"
                        id={`deletetooltip-${uniqueId}`}
                      />
                      <UncontrolledTooltip
                        placement="top"
                        target={`deletetooltip-${uniqueId}`}
                      >
                        Delete
                      </UncontrolledTooltip>
                    </Link>
                  )}
                </div>
              );
            },
          }
        : null;

    return [
      ...(actionColumn ? [actionColumn] : []), // Show only if access
      {
        Header: "S.No",
        Cell: ({ row }) => departments.length - row.index,
        className: "serial-no",
        applyHeaderClass: true,
      },
      {
        Header: "Department Code",
        accessor: "departmentcode",
      },
      {
        Header: "Department Name",
        accessor: "departmentname",
      },
      {
        Header: "Created By",
        accessor: "createdby",
      },
      {
        Header: "Created On",
        accessor: "createddate",
      },
    ];
  }, [departments, canEdit, canDelete]);

  const handleToggleStatus = (row) => {
    Swal.fire({
      title: 'Are you sure?',
      html: `You are about to delete <strong>${row.departmentname}</strong> department`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("departmentid", row.departmentId);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("createdby", authDetails?.user_id);
        dispatch(deleteDepartment(formData));
      }
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Setup" breadcrumbItem="Department" />

          {/* Input Section */}
          {(canCreate || canEdit) && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3">
                  <Col md="4" lg="4" xl="4">
                    <FormGroup>
                      <Label for="departmentcode">
                        Department Code <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="departmentcode"
                        name="departmentcode"
                        type="text"
                        maxLength={10}
                        value={formik.values.departmentcode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.departmentcode &&
                          Boolean(formik.errors.departmentcode)
                        }
                      />
                      {formik.touched.departmentcode && formik.errors.departmentcode && (
                        <div className="text-danger">{formik.errors.departmentcode}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="5" lg="5" xl="5">
                    <FormGroup>
                      <Label for="departmentname">
                        Department Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="departmentname"
                        name="departmentname"
                        type="text"
                        maxLength={50}
                        value={formik.values.departmentname}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.departmentname &&
                          Boolean(formik.errors.departmentname)
                        }
                      />
                      {formik.touched.departmentname && formik.errors.departmentname && (
                        <div className="text-danger">{formik.errors.departmentname}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md="3" lg="3" xl="3" className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" className=" btn button-save me-2">
                      <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                    </Button>
                    <Button type="button" onClick={handleCancel} className="btn button-cancel">
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={departments && departments.length > 0 ? departments : []}
                isGlobalFilter={true}
                customPageSize={10}
              // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Department;
